import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { get } from "@insite/client-framework/Services/ApiService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import useConstructor from "@preferredMedical/Components/Misc/UseConstructor";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    message: string;
}

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
    language: state.context.session.language
});

type Props = WidgetProps & OwnProps & HasProduct & ReturnType<typeof mapStateToProps>;

const cssWrapper = {
    css: css`
            margin-top: 30px;
            text-align: center;
        `,
};

export interface LastPurchasedModel {
    date: string
}

const LastPurchasedMessage: React.FC<Props> = ({ product, session, language, fields }) => {
    if (!product || !product.productNumber) {
        return null;
    }
    
    if (!session.isAuthenticated) {
        return null;
    }

    const [lastPurchased, setLastPurchased] = React.useState("");
    const locale = language?.cultureCode || language?.languageCode;

    useConstructor(async () => {
        const lastPurchasedResponse = await get<LastPurchasedModel>(`api/v1/Product/LastPurchased/${product.productNumber}`);
        if (lastPurchasedResponse && lastPurchasedResponse.date) {
            const lastPurchasedDisplay = new Date(lastPurchasedResponse.date).toLocaleString(locale, {
                year: "numeric",
                month: "numeric",
                day: "numeric"
            });
            setLastPurchased(lastPurchasedDisplay);
        }
    });        

    const isLastPurchased = () : boolean => lastPurchased?.length > 0;

    return (
        <StyledWrapper {...cssWrapper}>
            {isLastPurchased() && (
                <Typography>{fields.message} {lastPurchased}</Typography>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(LastPurchasedMessage)),
    definition: {
        displayName: "Last Purchased Message",
        group: "Product Details",
        fieldDefinitions: [
            {
                name: "message",
                displayName: "Message",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "Last purchased this product on",
                isRequired: true,
            },
        ],
        allowedContexts: ["ProductDetailsPage"]
    },
};

export default widgetModule;
